import { Box, BoxProps, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import DisplayEmptyListAction from "../../../../../../../components/DisplayEmptyListAction";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import { useState } from "react";
import DialogAddRateio from "./DialogAddRateio";
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { TitPagarRateio } from "../../../../../../../types/api/financeiro/detalhar-titulo-pagar";

export default function RateioDetalhe({
    codigo,
    valores,
    boxStyle,
    valorTotal
}: RateioDetalheProps) {

    const [openSelect, setOpenSelect] = useState<boolean>(false)

    //valores importantes
    const paddingStyle = { paddingLeft: 0, paddingRight: 0 }

    const Actions = () => (
        <Stack direction="row" gap={2}>
            <Button
                variant="outlined"
                size="small"
                startIcon={<AttachMoneyIcon />}
                onClick={() => setOpenSelect(true)}
                disabled={valorTotal === 0}
            >
                Adicionar rateio
            </Button>
        </Stack>
    )
    //

    return (
        <>
            <Box {...boxStyle}>
                <Typography variant="h6">Rateio por centro de custo</Typography>
                {
                    (!valores || valores?.length === 0) &&
                    <>
                        <DisplayEmptyListAction
                            label="Nenhum centro de custo selecionado. Deseja adicionar?"
                            actionSection={<Actions />}
                        />
                        {
                            openSelect &&
                            <DialogAddRateio
                                {...{ codigo, valorTotal }}
                                open={openSelect}
                                handleClose={() => setOpenSelect(false)}
                            />
                        }
                    </>
                }

                {
                    (valores && valores.length > 0) &&
                    <>
                        <TableContainer>
                            <Table size="small" aria-label="a dense table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={paddingStyle}><b>Centro de custo</b></TableCell>
                                        <TableCell sx={paddingStyle} align="right"><b>Valor rateio</b></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {valores.map((row, index) => {
                                        return (
                                            <TableRow
                                                key={index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell sx={paddingStyle} component="th" scope="row">
                                                    <Stack>
                                                        <Typography variant="subtitle2">
                                                            {row.conta_devedora ?
                                                                `${row.conta_devedora.codigo} - ${row.conta_devedora.nome}` : "-"}
                                                        </Typography>
                                                        {row.centro_custo &&
                                                            <Typography variant="caption" color="gray">
                                                                Centro custo: {`${row.centro_custo.codigo} - ${row.centro_custo.nome}`}
                                                            </Typography>
                                                        }
                                                    </Stack>
                                                </TableCell>
                                                <TableCell sx={paddingStyle} align="right">{formatarValorMonetario(row.valor_rateio)}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                }
            </Box>
        </>
    )
}

interface RateioDetalheProps {
    codigo: string
    valores: TitPagarRateio[]
    boxStyle: BoxProps
    valorTotal: number
}
